import {Injectable} from '@angular/core';
import {StancheckBackendService} from './backend.service';
import {PortalService} from '../../services/portal.service';
import {Router} from "@angular/router";
import {RequestService} from "../../services/request.service";
import {EmbedService} from "../../services/embed.service";
import {RequestAnfrage} from "../../model/request.anfrage";
import {StancheckAnfrage} from "../anfrage/stancheck.anfrage";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class StancheckRequestService extends RequestService{

  /**
   * @inheritdoc
   */
  requestObjectName = 'sac-anfrage';

  /**
   * constructor.
   */
  constructor(
    protected backendService: StancheckBackendService,
    private router: Router,
    protected portalService: PortalService,
    protected embedService: EmbedService,
  ) {
    super(backendService, portalService, embedService);

    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));

        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/stancheck/ergebnis/analyse']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new StancheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): StancheckAnfrage {
    return super.getAnfrage() as StancheckAnfrage;
  }
}
